import { render, staticRenderFns } from "./others.vue?vue&type=template&id=2a3b1956"
import script from "./others.js?vue&type=script&lang=js&external"
export * from "./others.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports